// Outgoing quote mails (quote PDF + selected documents + always-attach documents) may not exceed
// this many raw bytes of attachments. Base64 adds a third on the wire, and the recipient's
// mailbox decides the real ceiling (Gmail 25 MB, corporate gateways often less), so the ceiling
// an admin may configure stays well under that.
export interface IQuoteMailSettings {
    attachmentBudgetBytes: number;
}

export const QUOTE_MAIL_ATTACHMENT_BUDGET_CEILING_BYTES = 25 * 1024 * 1024;

export const QUOTE_MAIL_SETTINGS_FALLBACK: IQuoteMailSettings = {
    attachmentBudgetBytes: 15 * 1024 * 1024,
};
